import { Injectable, inject } from '@angular/core';

import { NavigationService } from '@frontend/vanilla/core';

import { ConfigProviderService } from '../../config-provider/config-provider.service';
import { GlobalSearchCustomEvent } from './global-search.model';

@Injectable({
    providedIn: 'root',
})
export class GlobalSearchService {
    private readonly navigation = inject(NavigationService);
    private readonly configProviderService = inject(ConfigProviderService);
    hideGlobalSearchBasedOnPath: boolean = false;

    hideGlobalSearchHeaderAndStickyEntryBasedOnPath(): boolean {
        const getCurrentPath: string = this.navigation.location.pathname;
        const globalSearchConfig = this.configProviderService.provideGlobalSearchConfig();
        const globalSearchPathBasedEnabler = globalSearchConfig.pathBasedEnabler;
        const disabledGlobalSearchPaths: string[] = globalSearchPathBasedEnabler.disablePaths;
        const enabledGlobalSearchPaths: string[] = globalSearchPathBasedEnabler.enablePaths;
        if (globalSearchPathBasedEnabler) {
            this.hideGlobalSearchBasedOnPath = disabledGlobalSearchPaths.some((disablePath) => getCurrentPath.includes(disablePath));
        } else if (enabledGlobalSearchPaths) {
            this.hideGlobalSearchBasedOnPath = !enabledGlobalSearchPaths.some((enablePath) => getCurrentPath.includes(enablePath));
        } else {
            this.hideGlobalSearchBasedOnPath = false;
        }
        return this.hideGlobalSearchBasedOnPath;
    }

    hideGlobalSearch(): void {
        dispatchEvent(new CustomEvent(GlobalSearchCustomEvent.HIDE_HEADER_ENTRY));
        dispatchEvent(new CustomEvent(GlobalSearchCustomEvent.HIDE_FLOATING_ENTRY));
    }

    showGlobalSearch(): void {
        dispatchEvent(new CustomEvent(GlobalSearchCustomEvent.SHOW_HEADER_ENTRY));
        dispatchEvent(new CustomEvent(GlobalSearchCustomEvent.SHOW_FLOATING_ENTRY));
    }

    hidingGlobalSearch(): void {
        if (this.hideGlobalSearchHeaderAndStickyEntryBasedOnPath() && this.hideGlobalSearchBasedOnPath) {
            this.hideGlobalSearch();
        } else {
            this.showGlobalSearch();
        }
    }
}
